import { useEffect, useLayoutEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useBrowseListings, useUserSelfDetails } from '@steelbuy/data-access';
import { DashboardFormData, useDashboardFormContext } from './DashboardFormContext';
import { DashboardListingsResults } from './DashboardListingsResults';
import { buildRequestBody } from './dashboardListingsUtil';
import { DashboardMaterialSelection } from './DashboardMaterialSelection';
import { RoutePath } from '../../router/Routes';
import { TableLayout } from '../../views/layouts/table-layout/TableLayout';
import { getScrollTopMainLayout } from '../app-layout/app-main-layout/AppMainLayout';
import { PageHeader } from '../page-header/PageHeader';
import { useScrollPositionContext } from '../scroll-position/ScrollPositionContext';

import './DashboardListings.scss';

export const DashboardListings = () => {
    const { t } = useTranslation(['translation', 'domainModel']);
    const { data: userModel } = useUserSelfDetails();
    const { getDashboardFormData, setDashboardFormData } = useDashboardFormContext();
    const methods = useForm<DashboardFormData>({
        defaultValues: {
            ...getDashboardFormData(),
        },
    });
    const { control, getValues } = methods;
    const formValues = useWatch({ control });
    const listingsQuery = useBrowseListings(buildRequestBody(formValues as DashboardFormData));
    const {
        data: listings,
        total,
        isFetching,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        isInitialLoading,
    } = listingsQuery;
    const { setScrollPosition } = useScrollPositionContext();

    useEffect(
        () => () => {
            setDashboardFormData(getValues() as DashboardFormData);
        },
        []
    );

    useLayoutEffect(
        () => () => {
            setScrollPosition(RoutePath.DASHBOARD, getScrollTopMainLayout());
        },
        []
    );

    return (
        <>
            <PageHeader pageTitle={t('application.dashboard.headerTitle', { name: userModel?.name ?? '' })} />
            <div className="dashboard-listings">
                <TableLayout>
                    <FormProvider {...methods}>
                        <DashboardMaterialSelection />
                        <DashboardListingsResults
                            total={total}
                            listings={listings}
                            formData={formValues}
                            isFetching={isFetching}
                            hasNextPage={hasNextPage}
                            loadMore={fetchNextPage}
                            isFetchingNextPage={isFetchingNextPage}
                            isInitialLoading={isInitialLoading}
                        />
                    </FormProvider>
                </TableLayout>
            </div>
        </>
    );
};
